import { useState } from "react";
import { Helmet } from "react-helmet";
import BackButton from "../components/BackButton";

export default function CaseConverter() {
  const [text, setText] = useState("");
  const [converted, setConverted] = useState("");

  const convertToUpper = () => setConverted(text.toUpperCase());
  const convertToLower = () => setConverted(text.toLowerCase());

  const convertToCapitalized = () => {
    const result = text
      .toLowerCase()
      .split(" ")
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
    setConverted(result);
  };

  const convertToSentence = () => {
    const result = text
      .toLowerCase()
      .replace(/(^\s*\w|[.!?]\s*\w)/g, c => c.toUpperCase());
    setConverted(result);
  };

  const removeDuplicateLines = () => {
    const lines = text.split("\n");
    const uniqueLines = [...new Set(lines)];
    setConverted(uniqueLines.join("\n"));
  };

  const reverseText = () => {
    setConverted(text.split("").reverse().join(""));
  };

  const copyToClipboard = () => {
    navigator.clipboard.writeText(converted);
    alert("Copied to clipboard!");
  };

  return (
    <>
      <Helmet>
        <title>Text Case Converter, Remove Duplicates, Reverse Text Online</title>
        <meta
          name="description"
          content="Free online Text Case Converter tool to change to UPPERCASE, lowercase, Capitalized, Sentence case, remove duplicate lines, and reverse text instantly."
        />
        <meta name="keywords" content="text case converter, remove duplicate lines, reverse text, uppercase lowercase, capitalize text, online converter" />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://freelity.com/text-case-converter" />
      </Helmet>

      <section className="sec-free-tools">
        <div className="container">
          <BackButton />
          <h2>Text Converter Tool</h2>
          <textarea
            rows="6"
            className="form-control mb-3"
            placeholder="Enter your text here..."
            value={text}
            onChange={(e) => setText(e.target.value)}
          />

          <div className="d-flex flex-wrap gap-2 mb-3">
            <button className="btn btn-primary" onClick={convertToUpper}>UPPERCASE</button>
            <button className="btn btn-secondary" onClick={convertToLower}>lowercase</button>
            <button className="btn btn-warning" onClick={convertToCapitalized}>Capitalized Case</button>
            <button className="btn btn-info" onClick={convertToSentence}>Sentence case</button>
            <button className="btn btn-dark bigsize" onClick={removeDuplicateLines}>Remove Duplicate Lines</button>
            <button className="btn btn-outline-danger" onClick={reverseText}>Reverse Text</button>
          </div>

          <textarea
            rows="6"
            className="form-control mb-3"
            value={converted}
            readOnly
          />

          <button className="btn btn-success" onClick={copyToClipboard}>
            Copy to Clipboard
          </button>
        </div>
      </section>
    </>
  );
}
